import { render } from "./Tab1.vue?vue&type=template&id=866d473c&scoped=true"
import script from "./Tab1.vue?vue&type=script&lang=js"
export * from "./Tab1.vue?vue&type=script&lang=js"

import "./Tab1.vue?vue&type=style&index=0&id=866d473c&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-866d473c"]])

export default __exports__